module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-23.867b3a07.png";